import { connect } from "react-redux";
import CoupleHeading from "../../CoupleHeading/CoupleHeading";
import Hashtag from "../../Hashtag/Hashtag";
import { getCloudinaryFullPath } from "../../../utils";
import PearlFrame from "../art/PearlFrame";
import Reveal from "../Reveal";
import Section from "./Section";
import Person from "../../Person/Person";
import { isJainInvite } from "../helpers";

// The bride and groom (shared components/Person) in Royal Mahal's pearl frames, with the
// grandparents line and the invite-specific lines
const RM_PERSON = { prefix: "rm", Reveal, Frame: PearlFrame };

/**
 * The blessing, the couple's welcome line, their hashtag, and the bride & groom.
 * A couple photo, when added, is shown once above the pair in place of the bride's
 * and groom's own portraits; otherwise each shows their own photo, if any.
 */
const Couple = ({ bride, groom, couplePhoto, religion, pathname, isFromPortfolio }) => {
  return (
    <Section
      id="couple"
      className="rm-couple"
      label="The bride and groom"
      flora="spray-right"
      seed={5}
      // kicker={isJainInvite(religion) ? "|| Shree Mahaveeray Namah ||" : "|| Shree Ganeshay Namah ||"}
    >
      <Reveal className="rm-couple__welcome" delay={0.1}>
        <CoupleHeading />
        <Hashtag />
      </Reveal>

      <div className="rm-couple__pair">
        <Person
          {...RM_PERSON}
          data={bride || {}}
          isGroom={false}
          hidePhone={isFromPortfolio}
          hidePhoto={!!couplePhoto}
          pathname={pathname}
          delay={0.1}
        />
        {couplePhoto ? (
          <Reveal className="rm-couple__photo" delay={0.1}>
            <PearlFrame className="rm-couple__portrait" src={getCloudinaryFullPath(couplePhoto)} alt="The bride and groom" />
          </Reveal>)
          : <Reveal effect="fade" className="rm-couple__and" delay={0.3}>
            <span className="rm-script">&amp;</span>
          </Reveal>}
        <Person
          {...RM_PERSON}
          data={groom || {}}
          isGroom={true}
          hidePhone={isFromPortfolio}
          hidePhoto={!!couplePhoto}
          pathname={pathname}
          delay={0.2}
        />
      </div>
    </Section>
  )
};

const mapStateToProps = (state) => ({
  bride: state.inviteDetails.invite?.bride,
  groom: state.inviteDetails.invite?.groom,
  couplePhoto: state.inviteDetails.invite?.couplePhoto,
  religion: state.inviteDetails.invite?.religion,
  pathname: state.inviteDetails.invite?.pathname,
  isFromPortfolio: state.common?.isFromPortfolio,
});

export default connect(mapStateToProps)(Couple);
